import { cn } from "@/lib/utils"

interface RequiredBadgeProps {
  className?: string
}

export function RequiredBadge({ className }: RequiredBadgeProps) {
  return (
    <span
      className={cn(
        "ml-1 px-1 py-0.5 bg-[#ff3232] rounded-[3px] text-xs font-semibold text-white",
        className
      )}
    >
      必須
    </span>
  )
}
